import React from 'react';
import './footer.module.scss';
import { Page } from 'react-facebook';
import { observer } from 'mobx-react';
import { GlobalStatesV3 } from '../../../../commonv3/states/GlobalStatesV3';
import { Link } from 'react-router-dom';
import { V3Routes } from '../../../routes';

export class TwitterWidget extends React.Component {
    twitterWrapper: any = null;
    componentDidMount(): void {
        if (this.twitterWrapper) {
            const script = document.createElement('script');
            script.src = 'https://platform.twitter.com/widgets.js';
            script.async = true;
            this.twitterWrapper.appendChild(script);
        }
    }
    render() {
        return (
            <div styleName="twitter" ref={(ref) => (this.twitterWrapper = ref)}>
                <a
                    className="twitter-timeline"
                    data-width={!GlobalStatesV3.viewport.isSp ? '400px' : '100%'}
                    data-height="600px"
                    href="https://twitter.com/she_officials?ref_src=twsrc%5Etfw"
                >
                    Tweets by she_officials
                </a>
            </div>
        );
    }
}

export const FacebookWidget = () => (
    <div styleName="facebook">
        <Page
            href="https://www.facebook.com/shelikes.jp/"
            tabes="timeline"
            width={!GlobalStatesV3.viewport.isSp ? '400px' : undefined}
            height="600px"
            smallHeader={true}
            adaptContainerWidth={true}
            hideCover={false}
            showFacepile={true}
        />
    </div>
);

type Props = {
    bottomNote?: any;
};

@observer
export class Footer extends React.Component<Props> {
    render() {
        const { bottomNote } = this.props;
        return (
            <footer styleName="footer">
                <div styleName="section">
                    <div>
                        <div styleName="link">
                            <div styleName="link-title">
                                <a href="https://she-inc.jp/">SHE | ミレニアルライフコーチングカンパニー</a>
                            </div>
                            <div styleName="link-content">
                                <ul>
                                    <li>SHElikes</li>
                                    <li>|</li>
                                    <li>
                                        <a href="https://shares.she-inc.jp/" target="_blank">
                                            SHEshares
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div styleName="link">
                            <div styleName="link-title">SHEに関する情報</div>
                            <div styleName="link-content">
                                <ul>
                                    <li>
                                        <a target="_blank" href="https://she-inc.jp/about">
                                            運営会社
                                        </a>
                                    </li>
                                    <li>|</li>
                                    <li>
                                        <a target="_blank" href="https://she-inc.jp/common/agreement.html">
                                            利用規約
                                        </a>
                                    </li>
                                    <li>|</li>
                                    <li>
                                        <Link to={V3Routes.pricing()}>料金プラン</Link>{' '}
                                    </li>
                                    <li>|</li>
                                    <li>
                                        <a target="_blank" href="https://she-inc.jp/common/policy.html">
                                            プライバシーポリシー
                                        </a>
                                    </li>
                                    <li>|</li>
                                    <li>
                                        <a
                                            target="_blank"
                                            href="https://she-files-public.s3-ap-northeast-1.amazonaws.com/%E7%89%B9%E5%AE%9A%E5%95%86%E5%8F%96%E5%BC%95%E6%B3%95%E3%81%AB%E5%9F%BA%E3%81%A4%E3%82%99%E3%81%8F%E8%A1%A8%E7%A4%BA.pdf"
                                        >
                                            特定商取引法に基づく表示
                                        </a>
                                    </li>
                                    <li>|</li>
                                    <li>
                                        <Link to={V3Routes.faq()}>お問い合わせ</Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div styleName="copyright">
                    <p>© SHE inc. All Rights Reserved.</p>
                </div>
                <div styleName="section sns-widgets">
                    <TwitterWidget />
                    <FacebookWidget />
                </div>
                {bottomNote && <div styleName="bottom-note">{bottomNote}</div>}
            </footer>
        );
    }
}
